import { createAction, props } from "@ngrx/store"
import { SesionUsuario } from "../../interfaces/SesionUsuario.interface"

export const loadLogin = createAction("[Login] Load Login Page")

export const loginSuccess = createAction(
  "[Login] Login Success",
  props<{ sesionUsuario: SesionUsuario }>()
)
